<template>
  <div>
    <b-modal ref="modalIframe" size="lg" centered :hide-header="true" :hide-footer="true" lazy>
      <div class="py-5 px-2 px-lg-4">

        <button type="button" class="ml-auto close" @click="$refs['modalIframe'].hide()">
          <close-icon class="h4 my-0 ml-auto" />
        </button>

        <iframe :src="iframeUrl" frameborder="0" width="100%" height="400" ></iframe>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import CloseIcon from "vue-material-design-icons/Close.vue"
  export default {
    name: 'modalIframe',
    data() {
      return {
        isLoading: false,
        iframeUrl: ''
      }
    },
    mounted() {
      this.$EventBus.$on('showModalIframe', (url) => {
        this.iframeUrl = url + '#toolbar=0&navpanes=0&scrollbar=0';
        this.$refs['modalIframe'].show();
      });
    },
    destroyed() {
      this.$EventBus.$off('showModalIframe');
    },
    components: {
      CloseIcon
    },
    methods: {
    },
  }
</script>

<style lang="scss" scoped></style>